export const theme = {
    primaryDark: 'black',
    primaryLight: 'white',

    mobile: '320px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1300px'

  }